export const SUSPENDAVILABLEDAY = 25;

export const COMPLAINT_STATUS={
    RESOLVED: 1,
    PENDING: 2,
    DISPUTED: 3 
}
